import React from "react";

const Main = (props) => {
    return (
        <main role="main">
            <div className="main-content">{props.children}</div>
        </main>
    );
};

export default Main;
